module.exports = __webpack_public_path__ + "img/6.9f09b2ca.jpg";